import { getLang, getLangString } from "../../../i18n/translate";

export function Track({ subtitles }: { subtitles: string }) {
  const emptySubtitles = "subtitles/empty.vtt";

  return (
    <track
      kind="subtitles"
      key={subtitles}
      src={subtitles || emptySubtitles}
      label={getLangString()}
      srcLang={getLang()}
      default
    />
  );
}
